import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-validated-textarea',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './validated-textarea.component.html',
  styleUrl: './validated-textarea.component.scss',
})
export class ValidatedTextAreaComponent {
  label = input.required<string>();
  rows = input.required<number>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl>();
  maxLength = input<number>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);
  placeholder = input<string>('');

  hasRequiredValidator(): string | boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }

  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }
}
